(function() {
    'use strict';
 
 
a3_pilot_reports.controller('SynchCtrl',SynchCtrl);

    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name SynchCtrl
    * @description 
    *  Manage Sync View
    * @ngInject
    */  
function SynchCtrl($scope, $uibModalInstance, UserFactory, FlightFactory, PilotReportLocalEditFactory, SyncAPIService, SyncLogFactory, ReportGuidFactory,PilotReportSyncResultFactory,DataCleanerFactory,MessageFactory,MemoFactory,$route) {
		$scope.syncResultsVisible = false;
		$scope.isSynching = false;

		// get the number of reports to synch
		var reportstobesynched = PilotReportLocalEditFactory.getPilotReportLocalEditThatNeedToBeSynched();
		
		// display the number of reports to synch
		$scope.number_of_reports_to_sync = reportstobesynched.length;
		
		// get the last sync date
		$scope.isFirstSync = false;
		$scope.isTooOldSync = false;
		$scope.lastSyncDate = '-';
		$scope.syncVersion = '1.1';
		
		var lastLog = SyncLogFactory.getSyncLog();
		if (lastLog == null) {
			$scope.isFirstSync = true;
		}
		else {
			if (lastLog.date != null) {
				$scope.lastSyncDate = new Date(lastLog.date).toUTC().toString('dd-MM-yyyy HH:mm') + ' UTC';
				if (Date.today().add(-3).days().toUTC().isAfter(new Date(lastLog.date).toUTC()))
					$scope.isTooOldSync = true;
			}
			
			if (lastLog.version != null)
				$scope.syncVersion = lastLog.version;
		}

		// get the report credits
		$scope.reportCredits = ReportGuidFactory.getRemainingReportGuids();
		
		// setup the grid
		$scope.syncTableData = PilotReportLocalEditFactory.getPilotReportLocalEditThatNeedToBeSynched();
		
		$scope.doSynch = doSynch;
        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.showSyncResults = showSyncResults;
        $scope.syncResultsOk = syncResultsOk;
       
        /**
        * Start Synch functionality
        * @memberof SynchCtrl
        */
        function doSynch() {
			//waiting for memoIds before we sync
			MemoFactory.getStoredMemosIds(function(memoIdsToSend){
								// get the user
								var user = UserFactory.getUser();

								// call the remote service for data
								var q = SyncAPIService.doSync(user.aimsId,memoIdsToSend);
								$scope.isSynching = true;

								q.then(function(response){
										$scope.isSynching = false;
										if ($scope.number_of_reports_to_sync > 0) {
												$scope.showSyncResults('synched');
										} else {
												$scope.showSyncResults('synched-no-send');
										}
								 DataCleanerFactory.deleteSynchedLocalPilotReports();
								 DataCleanerFactory.deleteOrphanedLocalReports();
								 SyncAPIService.updatePilotReportLocalEditFromSynch();
								 MemoFactory.markGroundDutiesUnread();
								});

								q.catch(function(err){
										$scope.isSynching = false;

										if (err.status == -1)
										{
												$scope.errorName = "There were problems during the server synchronization. Please try again.";
										}
										else if (err.status != 401)
										{
												// if an error was encountered display an error message
												$scope.errorName = "Could not reach the remote server. Please connect to the Internet and try again.";
										}
										else
										{
												$uibModalInstance.close('');
										}
								});
						})
						
		};
		
        /**
        * Close  modal
        * @memberof SynchCtrl
        */
        function ok() {
			$uibModalInstance.close('');
		};

        /**
        * show Report Sync Results
        * @memberof SynchCtrl
        */
		function cancel() {
			$uibModalInstance.close('cancel');

		};
    
        /**
        * show Report Sync Results
        * @memberof SynchCtrl
        */
        function showSyncResults(syncResult) {

			$scope.syncResultsVisible = true;

			// setup the grid
			$scope.syncResultsTableData = PilotReportSyncResultFactory.getPilotReportSyncResultsFromStorage();
			$scope.syncSuccesses = PilotReportSyncResultFactory.getSuccesses($scope.syncResultsTableData);
			$scope.syncFailures = PilotReportSyncResultFactory.getFailures($scope.syncResultsTableData);
						
						
			if ($scope.syncResultsTableData != null) {
					$scope.reports_to_sync = $scope.syncResultsTableData.length;
			} else {
					$scope.reports_to_sync = 0;
			}

			if ($scope.syncSuccesses == 1) {
					$scope.sync_successes_descr = 'Pilot Report was';
			} else {
					$scope.sync_successes_descr = 'Pilot Reports were';
			}

			if ($scope.syncFailures == 1) {
					$scope.sync_failures_descr = 'Pilot Report was';
			} else {
					$scope.sync_failures_descr = 'Pilot Reports were';
			}
			
			$scope.unreadMessages=MessageFactory.getCountOfUnreadMessages();
		};

        /**
        * show Report Sync Results
        * @memberof SynchCtrl
        */
		function syncResultsOk() {
			$uibModalInstance.close('synched');
			$route.reload();

		}

}

		
 
 })();   